
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","fill":"#A4D24F"}}),_c('path',{attrs:{"d":"M9.5 15.273V8h2.784c.526 0 .962.083 1.31.249.35.163.612.387.785.67.176.285.263.607.263.967 0 .296-.057.549-.17.76a1.433 1.433 0 01-.458.507c-.192.13-.406.224-.643.28v.072c.258.014.505.093.742.238.239.142.434.343.586.604.151.26.227.575.227.944 0 .377-.091.715-.273 1.016-.183.298-.457.534-.824.707-.367.172-.829.259-1.385.259H9.5zm1.318-1.101h1.416c.479 0 .823-.091 1.034-.274a.897.897 0 00.32-.71 1.088 1.088 0 00-.615-.994 1.51 1.51 0 00-.703-.153h-1.452v2.13zm0-3.079h1.303c.227 0 .432-.041.614-.124.182-.085.326-.205.43-.359a.96.96 0 00.16-.554c0-.282-.1-.514-.299-.696-.196-.182-.489-.273-.877-.273h-1.331v2.006z","fill":"#000"}})])
          )
        }
      }
    